import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
// import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../slices";

const UserSelect = ({ options }) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user?.userId);

  useEffect(() => {
    const { label, id, ...restProps } = options[0];
    const defaultUser = { userId: id, ...restProps };
    dispatch(updateUser(defaultUser));
  }, [dispatch, options]);

  return (
    <Select
      classNamePrefix="users-select"
      isClearable={false}
      backspaceRemovesValue={true}
      hideSelectedOptions={true}
      placeholder={"Select user id..."}
      options={options.map((opt) => {
        const { label, id, ...restProps } = opt || {};
        return { label: opt.label, value: opt.id, restProps };
      })}
      value={options.find(({ label, id }) => id === userId)}
      onChange={(selected, { action }) => {
        // const selectedVal = selected?.value || null;
        const selectedUser = selected
          ? { userId: selected.value, ...selected.restProps }
          : null;
        dispatch(updateUser(selectedUser));
      }}
    />
  );
};

UserSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default UserSelect;
